import { classed } from "@/components/classed.config";
import { deriveClassed } from "@tw-classed/react";

const InputPrimitive = classed.input(
  "appearance-none bg-transparent border px-3 py-2 rounded-xs outline-0 w-full",
  "invalid:border-destructive invalid:ring-3 invalid:ring-destructive/20 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20",
  "placeholder:text-muted-foreground",
  "focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
  "disabled:cursor-not-allowed disabled:pointer-events-none disabled:bg-input/50 disabled:opacity-50",
  "read-only:bg-input/40",
  {
    variants: {
      size: {
        sm: "h-8",
        md: "h-10",
        lg: "h-12",
      },
    },
    defaultVariants: {
      size: "lg",
    },
  },
);

const Input = deriveClassed<typeof InputPrimitive>((props, ref) => {
  return <InputPrimitive ref={ref} type="text" {...props} />;
});

const InputNamespace = Object.assign(Input, { id: "Input" });
export { InputNamespace as Input };
